import ImportButton from "@/app/shared/import-button";
import CreateEditShipment from "@/app/shared/shipments/create-edit";
import { shipmentData } from "@/app/shared/shipments/create-edit/form-utils";
import PageHeader from "@/app/shared/page-header";
import routes from "@/routers/routes";
import { useParams } from "react-router-dom";
import CreateEditOrder from "@/app/shared/orders/create-edit";
import { useEffect, useState } from "react";
import { fetchOrderById } from "@/server/api-services";
import { Order } from "@/types";
import toast from "react-hot-toast";

const pageHeader = {
    title: "Edit Order",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "Dashboard",
        },
        {
            href: routes.orders.list,
            name: "Orders",
        },
        {
            name: "Edit Order",
        },
    ],
};

interface HeaderProps {
    isAgent: boolean;
}

export default function EditOrderPage({ isAgent }: HeaderProps) {
    const { id } = useParams();

    const [order, setOrder] = useState<Order>({} as Order);

    useEffect(() => {
        fetchOrder();
    }, []);

    const fetchOrder = async () => {
        if (!id) return;

        const response = await fetchOrderById(id as string);

        if (response.statusCode !== 200) {
            toast.error("Failed to fetch order");
            return;
        }

        var data = response.data as Order;

        setOrder(data);
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
            </PageHeader>

            <CreateEditOrder id={id} order={order} isEdit={true} isAgent={isAgent} />
        </>
    );
}
